import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentsReasonQuery } from '../../queries/appointments_reason_query';
import { AppointmentsServiceCategoriesQuery } from '../../queries/appointments_service_categories_query';
import { AppointmentsServiceQuery } from '../../queries/appointments_service_query';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';
import { AppointmentsChoiceSelectorServant } from '../../servants/appointments_choice_selector_servant';
import MyAppointmentStateService from '../../services/my_appointment_state_service';
import { IAppointmentType, IStudentService, IStudentServiceCategory } from '../../types/appointment_interfaces';
import { TAppointmentReasonUsersource } from '../../usersources/appointment_reason_usersource';

export class AppointmentReasonController {
  private selectedTypeName: string;
  private selectedCategoryName: string;
  private selectedServiceName: string;
  private backText: string;
  private isLoading: boolean = true;

  constructor(
    private loadAppointmentTypeConfigurationServiceCommand: ICommand,
    private AppointmentsServiceSelectedCommand: ICommand,
    private ngAppointmentsReasonsQuery: AppointmentsReasonQuery,
    private AppointmentSchedulingTypeSelectedCommand: ICommand,
    private AppointmentsServiceCategorySelectedCommand: ICommand,
    public ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    public ngAppointmentsServiceCategoriesQuery: AppointmentsServiceCategoriesQuery,
    public ngAppointmentsServiceQuery: AppointmentsServiceQuery,
    private ngMyAppointmentsStateService: MyAppointmentStateService,
    private ngAppointmentsChoiceSelectorServant: AppointmentsChoiceSelectorServant,
    private ngAppointmentButtonServant: AppointmentButtonServant
  ) {
    this.backText = `Back to ${this.ngMyAppointmentsStateService.currentStep.title}`;
    this.setSelectedType = this.setSelectedType.bind(this);
    this.setSelectedCategory = this.setSelectedCategory.bind(this);
    this.setSelectedService = this.setSelectedService.bind(this);
    this.isLoading = true;
  }
  $onInit() {
    this.ngAppointmentsChoiceSelectorServant.refresh();
    this.ngAppointmentButtonServant.setDefaults();
    this.ngAppointmentButtonServant.buttonText = 'Continue to Location & Staff';
    if (!this.ngAppointmentReasonUsersource.read().selectedType.id) {
      this.loadAppointmentTypeConfigurationServiceCommand().then(() => {
        this.setValues();
        this.ngMyAppointmentsStateService.stateLoaded();
      });
    } else {
      this.setValues();
      this.ngMyAppointmentsStateService.stateLoaded();
    }
  }

  setValues(): void {
    this.isLoading = false;
    this.selectedTypeName = _4.get(this.ngAppointmentReasonUsersource.read().selectedType, 'name', '');
    this.selectedCategoryName = _4.get(this.ngAppointmentReasonUsersource.read().selectedCategory, 'name', '');
    this.selectedServiceName = _4.get(this.ngAppointmentReasonUsersource.read().selectedService, 'name', '');
  }

  setSelectedType(selectedType: IAppointmentType) {
    this.selectedTypeName = selectedType.name;
    this.selectedCategoryName = '';
    this.selectedServiceName = '';
    this.AppointmentSchedulingTypeSelectedCommand(selectedType);
  }
  setSelectedCategory(selectedCategory: IStudentServiceCategory) {
    this.selectedCategoryName = selectedCategory.name;
    this.selectedServiceName = '';
    this.AppointmentsServiceCategorySelectedCommand(selectedCategory);
  }
  setSelectedService(selectedService: IStudentService) {
    this.selectedServiceName = selectedService.name;
    this.AppointmentsServiceSelectedCommand(selectedService);
  }
}

angular.module('capability-ng-appointments').controller('ngAppointmentReasonController', AppointmentReasonController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/appointment_reason/appointment_reason.ts